export interface OutageBannerConfig {
    isActive: boolean;
    title: string;
    message: string;
    sessionStorageKey: string;
}

export const OUTAGE_BANNER_CONFIG: OutageBannerConfig = {
  isActive: false,
  title: "Upcoming Site Outage",
  message:
    "Starting on April 25 at 6:00 AM CST, and ending on April 26 at 11:59 PM CST, our site will be undergoing maintenance. " +
    "We apologize for the inconvenience and will provide updates here.",
  sessionStorageKey: "sd-650-outage-banner-dismissed",
};
